import type { MouseEventHandler } from 'react';

import ButtonBase from '@mui/material/ButtonBase';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material/styles';

const baseSx: SxProps<Theme> = { color: 'primary.main', fontSize: '16px' };

const clearAllButton = ({
  onClick,
  sx
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps<Theme>;
}) => (
  <ButtonBase
    sx={[baseSx, ...normalizeSx(sx)]}
    onClick={onClick}
  >
    Clear all
  </ButtonBase>
);

export default clearAllButton;
